/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatconverter1Inputs */

const en_formatconverter1 = /** @type {(inputs: Formatconverter1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image for Social Media Converter`)
};

const de_formatconverter1 = /** @type {(inputs: Formatconverter1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social-Media-Bildkonverter`)
};

/**
* | output |
* | --- |
* | "Image for Social Media Converter" |
*
* @param {Formatconverter1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const formatconverter1 = /** @type {((inputs?: Formatconverter1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatconverter1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatconverter1(inputs)
	return de_formatconverter1(inputs)
});
export { formatconverter1 as "formatConverter" }